import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, tap } from "rxjs";
import { ConfigurationItem } from "../../_objects/tenant-config";
import { ApiService } from "../base/api-base.service";
import { TenantConfigContractService } from "../interfaces/tenant-config-contract.service";
import { NetworkStatusService } from "../network-status.service";
import { TenantConfigOfflineService } from "../offline/tenant-config-offline.service";
import { TenantConfigOnlineService } from "../online/tenant-config-online.service";
import { TenantConfig } from "../../app.constants";
import { TenantDetail } from "../../_objects/offline-management";

@Injectable({
  providedIn: "root"
})
export class TenantConfigService extends ApiService<TenantConfigContractService> implements TenantConfigContractService {
  private _tenantConfig = new BehaviorSubject<ConfigurationItem[]>(null);
  private readonly attributeKeys = [
    TenantConfig.SubjectAttributeOwner.KEY,
    TenantConfig.SubjectAttributeCountry.KEY,
    TenantConfig.SubjectAttributeState.KEY,
    TenantConfig.SubjectAttributeDistrict.KEY,
    TenantConfig.SubjectAttributeSite.KEY,
    TenantConfig.SubjectAttributeProject.KEY
  ];

  constructor(
    protected networkStatusService: NetworkStatusService,
    protected offlineService: TenantConfigOfflineService,
    protected onlineService: TenantConfigOnlineService
  ) {
    super(networkStatusService, offlineService, onlineService);
  }

  setTenantConfig(tenantConfig: ConfigurationItem[]) {
    this._tenantConfig.next(tenantConfig);
  }

  get tenantConfig$(): Observable<ConfigurationItem[]> {
    return this._tenantConfig.asObservable();
  }
  get tenantConfig(): ConfigurationItem[] {
    return this._tenantConfig.getValue();
  }

  get visibleAttrExists(): boolean {
    return this.attributeKeys.some((k) => !this.isHide(k));
  }

  getTenantConfigs(): Observable<ConfigurationItem[]> {
    return this.fetchAndUpdate();
  }

  fetchAndUpdate(): Observable<ConfigurationItem[]> {
    return this.service.getTenantConfigs().pipe(tap((config) => this._tenantConfig.next(config)));
  }

  putTenantConfigs(configs: ConfigurationItem[]): Observable<ConfigurationItem[]> {
    return this.service.putTenantConfigs(configs);
  }

  getTenantDetails(): Observable<TenantDetail> {
    return this.service.getTenantDetails();
  }

  private isHide(attrKey: string): boolean {
    const config = this.tenantConfig?.find((c) => c.key === attrKey);
    return config && config.value === TenantConfig.HIDE;
  }

  public getConfigBykey(key: string): string | null {
    const configs = this.tenantConfig;
    if (configs) {
      const val = configs.find((_) => _.key === key);
      return val.selectItems[val.value as string].label as string;
    }
  }
}
